import {
  Button,
  Center,
  FormControl,
  HStack,
  Input,
  Select,
  Text,
  View,
  VStack,
  Box,
} from "native-base";
import React, { useMemo, useState, useEffect } from "react";
import TimeInput from "react-time-picker-input";
import Notiflix from "notiflix";

import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import PlacesAutocomplete from "../components/PlacesAutocomplete";
import { addressForLocation } from "../utils/placeAddress";
import { compose } from "redux";
import { connect } from "react-redux";
import { Redirect, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AddBiz } from "../Redux/actions";
import MultiImageInput from "../components/multi-image-input";

import { Multiselect } from "multiselect-react-dropdown";

import { useFirestoreConnect } from "react-redux-firebase";
import { useSelector } from "react-redux";
import AccessibilityForm from "./AccesibilityForm";

const AddBusiness = ({ auth }) => {
  useEffect(() => { document.title = "Add Business | Piatto"; }, []);
  const [formData, setFormData] = useState({});
  const history = useHistory();
  const dispatch = useDispatch();
  // need to add
  const [bizAddress, setbizAddress] = useState({ address: "" });
  const [bizLunchOpen, setBizLunchOpen] = useState("12:00"); //
  const [bizLunchClose, setBizLunchClose] = useState("15:00");
  const [bizDinnerOpen, setBizDinnerOpen] = useState("06:00");
  const [bizDinnerClose, setBizDinnerClose] = useState("21:30");

  const [bizName, setBizName] = useState(""); //
  const [bizType, setBType] = useState(""); /// bussinees types \

  //Nuber of seats
  const [bizInsideLowSeatNo, setBizInsideLowSeatNo] = useState("");
  const [bizInsideHighSeatNo, setBizInsideHighSeatNo] = useState("");
  const [bizOutsideLowSeatNo, setBizOutsideLowSeatNo] = useState("");
  const [bizOutsideHighSeatNo, setBizOutsideHighSeatNo] = useState("");
  // Number of tables
  const [bizInsideLowTableNo, setBizInsideLowTableNo] = useState("");
  const [bizInsideHighTableNo, setBizInsideHighTableNo] = useState("");
  const [bizOutsideLowTableNo, setBizOutsideLowTableNo] = useState("");
  const [bizOutsideHighTableNo, setBizOutsideHighTableNo] = useState("");
  //Open and Close
  const [bizMondayOpen, setBizMondayOpen] = useState("08:00"); //
  const [bizMondayClose, setBizMondayClose] = useState("21:30");
  const [bizTuesdayOpen, setBizTuesdayOpen] = useState("08:00");
  const [bizTuesdayClose, setBizTuesdayClose] = useState("21:30");
  const [bizWednesdayOpen, setBizWednesdayOpen] = useState("08:00");
  const [bizWednesdayClose, setbizWednesdayClose] = useState("21:30");
  const [bizThursdayOpen, setBizThursdayOpen] = useState("08:00");
  const [bizThursdayClose, setBizThursdayClose] = useState("21:30");
  const [bizFridayOpen, setBizFridayOpen] = useState("08:00");
  const [bizFridayClose, setbizFridayClose] = useState("21:30");
  const [bizSaturdayOpen, setbizSaturdayOpen] = useState("08:00");
  const [bizSaturdayClose, setBizSaturdayClose] = useState("21:30");
  const [bizSundayOpen, setBizSundayOpen] = useState("08:00");
  const [bizSundayClose, setBizSundayClose] = useState("21:30");
  const [BreakfastS, setBreakfastS] = useState("08:00");
  const [BreakfastF, setBreakfastF] = useState("10:00");

  const [wizard, Setwizard] = useState(0);

  const [bizPhone, setBizPhone] = useState("");
  const [bizEmail, setBizEmail] = useState("");
  const [bizWeb, setBizWeb] = useState("");
  const [bizAccessRating, setBizAccessRating] = useState(0);

  const [bizWebError, setBizWebError] = useState(false);

  const [bizOrderPhone, setBizOrderPhone] = useState("");
  const [bizOrderEmail, setBizOrderEmail] = useState("");
  const [bizOrderEmailError, setBizOrdermailError] = useState("");
  const [emailError, setEmailError] = useState("");

  const center = useMemo(() => ({ lat: 43.45, lng: -80.49 }), []);
  const [selected, setSelected] = useState(null);
  const [images, setImages] = React.useState({});

  const [bizCuisines, setBizCusines] = React.useState([]);

  // getting cuisines
  useFirestoreConnect([
    { collection: "Cuisines" },
    { collection: "Type" }
  ]);
  const Cuisine = useSelector(({ firestore: { ordered } }) => ordered.Cuisines);
  // getting busoiness types
  const BizTypes = useSelector(({ firestore: { ordered } }) => ordered.Type);

  // locationData: { lat, lng }. From an address pick, address + components
  // come with it (Places details); from a map click they don't, so we
  // reverse-geocode, and if that fails keep the pin and the previous address.
  const handleLatLang = async (locationData, address, components) => {
    setSelected(locationData);
    const add = await addressForLocation(locationData, address, components);
    if (add) {
      setbizAddress(add);
    } else {
      Notiflix.Report.Warning(
        "Address not updated",
        "We moved the pin but couldn't look up the street address for that spot. Search for the address instead if it's wrong.",
        "Close"
      );
    }
  };

  const handleBizOrderEmailChange = (text) => {
    setBizEmail(text);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (text.length === 0 || emailRegex.test(text)) {
      setEmailError("");
    } else {
      setEmailError("Invalid email address");
    }
  };

  const handleEmailChange = (text) => {
    setBizOrderEmail(text);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (text.length === 0 || emailRegex.test(text)) {
      setBizOrdermailError("");
    } else {
      setBizOrdermailError("Invalid email address");
    }
  };
  const crop = {
    unit: "%",
    aspect: 4 / 3,
    width: "100",
  };
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ["places"],
  });

  const handleScoreChange = (score) => {
    setBizAccessRating(score);
  };

  const isValidURL = (url) => {
    const pattern = new RegExp(
      "^(https?:\\/\\/)?(www\\.)?([\\w-]+\\.)+[\\w-]{2,}(:\\d+)?(\\/[^\\s]*)?$",
      "i"
    );
    return pattern.test(url);
  };

  const handleBizWebChange = (t) => {
    setBizWeb(t);
    setBizWebError(t.length > 0 && !isValidURL(t));
  };

   const handleFormChange = (updatedForm) => {
    setFormData(updatedForm); // keep latest form state
  };

  if (!auth.uid) return <Redirect to="/" />;

  return (
    <VStack
      role="main"
      flex="1"
      px="6"
      py="9"
      _light={{ bg: "white" }}
      _dark={{ bg: "coolGray.800" }}
      space="3"
      justifyContent="space-between"
    >
      <Center>
        <VStack textAlign={"center"} w={"70%"} space={4}>
          {wizard === 0 && (
            <View>
              <Text fontSize={"2xl"} fontWeight="bold">
                Add Business
              </Text>
              <Text mb={10} fontSize={"lg"}>
                Please input the following details about your business or
                connect us with your existing Google My Business account, to
                quickly enter your business into the Piatto database. Your
                business will quickly become visible in the Piatto app!
              </Text>
              <HStack justifyContent={"center"} space={2} flexWrap={"wrap"}>
                <FormControl w={"48%"}>
                  <FormControl.Label>Name of your business</FormControl.Label>
                  <Input
                    maxLength={20}
                    onChangeText={(txt) => {
                      const hasLetter = /[a-zA-Z]/.test(txt);
                      if (txt === "" || hasLetter) {
                        setBizName(txt);
                      }
                    }}
                    value={bizName}
                    autoComplete="off"
                    placeholder="Name of your business"
                  />
                </FormControl>

                <FormControl w={"48%"}>
                  <FormControl.Label>Your business type</FormControl.Label>
                  <Select
                    defaultValue={bizType["typeName"]}
                    onValueChange={(itemValue) => {
                      let bizTy = BizTypes.find(
                        (typ) => typ["typeName"] === itemValue
                      );
                      setBType(bizTy);
                    }}
                    accessibilityLabel="Select your Your business type"
                    placeholder="Select your Your business type"
                  >
                    {BizTypes &&
                      BizTypes.map((biz_) => {
                        return (
                          <Select.Item
                            label={biz_["typeName"]}
                            value={biz_["typeName"]}
                          />
                        );
                      })}

                    {/* <Select.Item label="Restaurant" value="Restaurant" />
                    <Select.Item label="Bar" value="Bar" />
                    <Select.Item label="Take Away" value="Take Away" />
                    <Select.Item label="Pop Up" value="Pop Up" />
                    <Select.Item label="Food Truck" value="Food Truck" /> */}
                  </Select>
                </FormControl>
              </HStack>
            </View>
          )}

          {wizard === 1 && (
            <View>
              <Text fontSize={"2xl"} fontWeight="bold">
                Business Location
              </Text>
              <Text mb={5} fontSize={"lg"}>
                Please inform us of your Business's location. The longitude and
                latitude values of your location will automatically be generated
                and inputted into our database along with your submission of
                this form.
              </Text>

              <FormControl>
                <FormControl.Label>Address</FormControl.Label>
              </FormControl>
              <div className="places-container">
                <PlacesAutocomplete setSelected={handleLatLang} />
              </div>
              {isLoaded && selected ? (
                <>
                  <GoogleMap
                    zoom={18}
                    center={selected ? selected : center}
                    onClick={(e) => {
                      const data = {
                        lat: e.latLng.lat(),
                        lng: e.latLng.lng(),
                      };
                      handleLatLang(data, null);
                    }}
                    mapContainerClassName="map-container"
                  >
                    {selected && <Marker position={selected} />}
                  </GoogleMap>
                </>
              ) : (
                <></>
              )}
            </View>
          )}

          {wizard === 2 && (
            <View>
              <Text fontSize={"2xl"} fontWeight="bold">
                Business Seating
              </Text>
              <Text mb={10} fontSize={"lg"}>
                Please inform us of the seating at your establishment, including
                the number of High and Low Tables, the number of tables both
                inside and outside, along with the number of seats at each
                category of table.
              </Text>
              <HStack justifyContent={"center"} space={2} flexWrap={"wrap"}>
                <FormControl w={"23%"}>
                  <FormControl.Label>
                    Total number of seats at inside low tables:
                  </FormControl.Label>
                  <Input
                    maxLength={2}
                    autoComplete="off"
                    value={bizInsideLowSeatNo}
                    onChangeText={(t) =>
                      setBizInsideLowSeatNo(t.replace(/[^0-9]/g, ""))
                    }
                    placeholder="inside low tables"
                  />
                </FormControl>
                <FormControl w={"23%"}>
                  <FormControl.Label>
                    Total number of seats at inside high tables:
                  </FormControl.Label>
                  <Input
                    maxLength={2}
                    autoComplete="off"
                    value={bizInsideHighSeatNo}
                    onChangeText={(t) =>
                      setBizInsideHighSeatNo(t.replace(/[^0-9]/g, ""))
                    }
                    placeholder="inside high tables"
                  />
                </FormControl>
                <FormControl w={"23%"}>
                  <FormControl.Label>
                    Total number of seats at outside low tables:
                  </FormControl.Label>
                  <Input
                    maxLength={2}
                    autoComplete="off"
                    value={bizOutsideLowSeatNo}
                    onChangeText={(t) =>
                      setBizOutsideLowSeatNo(t.replace(/[^0-9]/g, ""))
                    }
                    placeholder="outside low tables"
                  />
                </FormControl>
                <FormControl w={"23%"}>
                  <FormControl.Label>
                    Total number of seats at outside high tables:
                  </FormControl.Label>
                  <Input
                    maxLength={2}
                    autoComplete="off"
                    value={bizOutsideHighSeatNo}
                    onChangeText={(t) =>
                      setBizOutsideHighSeatNo(t.replace(/[^0-9]/g, ""))
                    }
                    placeholder="outside high tables"
                  />
                </FormControl>
                <FormControl w={"23%"}>
                  <FormControl.Label>
                    Total number of inside low tables:
                  </FormControl.Label>
                  <Input
                    maxLength={2}
                    autoComplete="off"
                    value={bizInsideLowTableNo}
                    onChangeText={(t) =>
                      setBizInsideLowTableNo(t.replace(/[^0-9]/g, ""))
                    }
                    placeholder="inside low tables"
                  />
                </FormControl>
                <FormControl w={"23%"}>
                  <FormControl.Label>
                    Total number of inside high tables:
                  </FormControl.Label>
                  <Input
                    maxLength={2}
                    autoComplete="off"
                    value={bizInsideHighTableNo}
                    onChangeText={(t) =>
                      setBizInsideHighTableNo(t.replace(/[^0-9]/g, ""))
                    }
                    placeholder="inside high tables"
                  />
                </FormControl>
                <FormControl w={"23%"}>
                  <FormControl.Label>
                    Total number of outside low tables:
                  </FormControl.Label>
                  <Input
                    maxLength={2}
                    autoComplete="off"
                    value={bizOutsideLowTableNo}
                    onChangeText={(t) =>
                      setBizOutsideLowTableNo(t.replace(/[^0-9]/g, ""))
                    }
                    placeholder="outside low tables"
                  />
                </FormControl>
                <FormControl w={"23%"}>
                  <FormControl.Label>
                    Total number of outside high table:
                  </FormControl.Label>
                  <Input
                    maxLength={2}
                    autoComplete="off"
                    value={bizOutsideHighTableNo}
                    onChangeText={(t) =>
                      setBizOutsideHighTableNo(t.replace(/[^0-9]/g, ""))
                    }
                    placeholder="outside high table"
                  />
                </FormControl>
              </HStack>
            </View>
          )}

          {wizard === 3 && (
            <View zIndex={99999}>
              <Text fontSize={"2xl"} fontWeight="bold">
                Trading Hours
              </Text>
              <Text mb={10} fontSize={"lg"}>
                Please indicate the opening and closing times for each day of
                the week that you are operating. Please also inform us of the
                Breakfast, Lunch and Dinner start/end times. They should be
                recorded in 24 hour time.
              </Text>
              <HStack
                zIndex={10}
                justifyContent={"center"}
                space={10}
                flexWrap={"wrap"}
              >
                <VStack alignItems={"center"}>
                  <FormControl.Label>Opening time on Monday:</FormControl.Label>
                  <TimeInput
                    value={bizMondayOpen}
                    fullTimeDropdown
                    onChange={(dateString) => setBizMondayOpen(dateString)}
                  />
                </VStack>
                <VStack alignItems={"center"}>
                  <FormControl.Label>Closing time on Monday:</FormControl.Label>
                  <TimeInput
                    value={bizMondayClose}
                    fullTimeDropdown
                    onChange={(dateString) => setBizMondayClose(dateString)}
                  />
                </VStack>
              </HStack>
              <HStack
                zIndex={9}
                justifyContent={"center"}
                space={10}
                flexWrap={"wrap"}
              >
                <VStack alignItems={"center"}>
                  <FormControl.Label>
                    Opening time on Tuesday:
                  </FormControl.Label>
                  <TimeInput
                    value={bizTuesdayOpen}
                    fullTimeDropdown
                    onChange={(dateString) => setBizTuesdayOpen(dateString)}
                  />
                </VStack>
                <VStack alignItems={"center"}>
                  <FormControl.Label>
                    Closing time on Tuesday:
                  </FormControl.Label>
                  <TimeInput
                    value={bizTuesdayClose}
                    fullTimeDropdown
                    onChange={(dateString) => setBizTuesdayClose(dateString)}
                  />
                </VStack>
              </HStack>
              <HStack
                zIndex={8}
                justifyContent={"center"}
                space={10}
                flexWrap={"wrap"}
              >
                <VStack alignItems={"center"}>
                  <FormControl.Label>
                    Opening time on Wednesday:
                  </FormControl.Label>
                  <TimeInput
                    value={bizWednesdayOpen}
                    fullTimeDropdown
                    onChange={(dateString) => setBizWednesdayOpen(dateString)}
                  />
                </VStack>
                <VStack alignItems={"center"}>
                  <FormControl.Label>
                    Closing time on Wednesday:
                  </FormControl.Label>
                  <TimeInput
                    value={bizWednesdayClose}
                    fullTimeDropdown
                    onChange={(dateString) => setbizWednesdayClose(dateString)}
                  />
                </VStack>
              </HStack>
              <HStack
                zIndex={7}
                justifyContent={"center"}
                space={10}
                flexWrap={"wrap"}
              >
                <VStack alignItems={"center"}>
                  <FormControl.Label>
                    Opening time on Thursday:
                  </FormControl.Label>
                  <TimeInput
                    value={bizThursdayOpen}
                    fullTimeDropdown
                    onChange={(dateString) => setBizThursdayOpen(dateString)}
                  />
                </VStack>
                <VStack alignItems={"center"}>
                  <FormControl.Label>
                    Closing time on Thursday:
                  </FormControl.Label>
                  <TimeInput
                    value={bizThursdayClose}
                    fullTimeDropdown
                    onChange={(dateString) => setBizThursdayClose(dateString)}
                  />
                </VStack>
              </HStack>
              <HStack
                zIndex={6}
                justifyContent={"center"}
                space={10}
                flexWrap={"wrap"}
              >
                <VStack alignItems={"center"}>
                  <FormControl.Label>Opening time on Friday:</FormControl.Label>
                  <TimeInput
                    value={bizFridayOpen}
                    fullTimeDropdown
                    onChange={(dateString) => setBizFridayOpen(dateString)}
                  />
                </VStack>
                <VStack alignItems={"center"}>
                  <FormControl.Label>Closing time on Friday:</FormControl.Label>
                  <TimeInput
                    value={bizFridayClose}
                    fullTimeDropdown
                    onChange={(dateString) => setbizFridayClose(dateString)}
                  />
                </VStack>
              </HStack>
              <HStack
                zIndex={5}
                justifyContent={"center"}
                space={10}
                flexWrap={"wrap"}
              >
                <VStack alignItems={"center"}>
                  <FormControl.Label>
                    Opening time on Saturday:
                  </FormControl.Label>
                  <TimeInput
                    value={bizSaturdayOpen}
                    fullTimeDropdown
                    onChange={(dateString) => setbizSaturdayOpen(dateString)}
                  />
                </VStack>
                <VStack alignItems={"center"}>
                  <FormControl.Label>
                    Closing time on Saturday:
                  </FormControl.Label>
                  <TimeInput
                    value={bizSaturdayClose}
                    fullTimeDropdown
                    onChange={(dateString) => setBizSaturdayClose(dateString)}
                  />
                </VStack>
              </HStack>
              <HStack
                zIndex={4}
                justifyContent={"center"}
                space={10}
                flexWrap={"wrap"}
              >
                <VStack alignItems={"center"}>
                  <FormControl.Label>Opening time on Sunday:</FormControl.Label>
                  <TimeInput
                    value={bizSundayOpen}
                    fullTimeDropdown
                    onChange={(dateString) => setBizSundayOpen(dateString)}
                  />
                </VStack>
                <VStack alignItems={"center"}>
                  <FormControl.Label>Closing time on Sunday:</FormControl.Label>
                  <TimeInput
                    value={bizSundayClose}
                    fullTimeDropdown
                    onChange={(dateString) => setBizSundayClose(dateString)}
                  />
                </VStack>
              </HStack>
              <HStack
                zIndex={3}
                justifyContent={"center"}
                space={10}
                flexWrap={"wrap"}
              >
                <VStack alignItems={"center"}>
                  <FormControl.Label>Breakfast start time:</FormControl.Label>
                  <TimeInput
                    value={BreakfastS}
                    fullTimeDropdown
                    onChange={(dateString) => setBreakfastS(dateString)}
                  />
                </VStack>
                <VStack alignItems={"center"}>
                  <FormControl.Label>Breakfast finish time:</FormControl.Label>
                  <TimeInput
                    value={BreakfastF}
                    fullTimeDropdown
                    onChange={(dateString) => setBreakfastF(dateString)}
                  />
                </VStack>
              </HStack>
              <HStack
                zIndex={2}
                justifyContent={"center"}
                space={10}
                flexWrap={"wrap"}
              >
                <VStack alignItems={"center"}>
                  <FormControl.Label>Lunch start time:</FormControl.Label>
                  <TimeInput
                    value={bizLunchOpen}
                    fullTimeDropdown
                    onChange={(dateString) => setBizLunchOpen(dateString)}
                  />
                </VStack>
                <VStack alignItems={"center"}>
                  <FormControl.Label>Lunch finish time:</FormControl.Label>
                  <TimeInput
                    value={bizLunchClose}
                    fullTimeDropdown
                    onChange={(dateString) => setBizLunchClose(dateString)}
                  />
                </VStack>
              </HStack>
              <HStack
                zIndex={1}
                justifyContent={"center"}
                space={10}
                flexWrap={"wrap"}
              >
                <VStack alignItems={"center"}>
                  <FormControl.Label>Dinner start time:</FormControl.Label>
                  <TimeInput
                    value={bizDinnerOpen}
                    fullTimeDropdown
                    onChange={(dateString) => setBizDinnerOpen(dateString)}
                  />
                </VStack>
                <VStack alignItems={"center"}>
                  <FormControl.Label>Dinner finish time:</FormControl.Label>
                  <TimeInput
                    value={bizDinnerClose}
                    fullTimeDropdown
                    onChange={(dateString) => setBizDinnerClose(dateString)}
                  />
                </VStack>
              </HStack>
            </View>
          )}

          {wizard === 4 && (
            <View zIndex={99999}>
              <Text mt={5} fontSize={"2xl"} fontWeight="bold">
                Business Picture
              </Text>

              <Text mb={10} fontSize={"lg"}>
                Please upload your business picture
              </Text>
              <VStack zIndex={99999}>
                <MultiImageInput
                  images={images}
                  max={5}
                  setImages={setImages}
                  cropConfig={{ crop, ruleOfThirds: true }}
                />
              </VStack>

              <Text fontSize={"2xl"} fontWeight="bold">
                Business Contact
              </Text>

              <Text mb={10} fontSize={"lg"}>
                Please inform us of your business contact details, along with a
                specific phone number and/or email address for ordering if one
                exists. We will not need these details to send orders to you, as
                you will have access to our Venue Dashboard upon submission of
                this form however it may help us to customise our service to
                you.
              </Text>
              <HStack justifyContent={"center"} space={2} flexWrap={"wrap"}>
                <FormControl w={"49%"}>
                  <FormControl.Label>
                    Phone number of business:
                  </FormControl.Label>

                  <Input
                    maxLength={12}
                    value={bizPhone}
                    onChangeText={(t) => setBizPhone(t.replace(/[^0-9]/g, ""))}
                    autoComplete="off"
                    placeholder="Phone number of business"
                  />
                </FormControl>
                <FormControl w={"49%"}>
                  <FormControl.Label>
                    Email address of business:
                  </FormControl.Label>

                  <Input
                    maxLength={25}
                    value={bizEmail}
                    onChangeText={handleBizOrderEmailChange}
                    autoComplete="off"
                    placeholder="Email address of business"
                  />
                  {emailError ? (
                    <Text style={{ color: "red", fontSize: 12 }}>
                      {emailError}
                    </Text>
                  ) : null}
                </FormControl>

                <FormControl w={"49%"}>
                  <FormControl.Label>Website of business:</FormControl.Label>
                  <Input
                    maxLength={105}
                    value={bizWeb}
                    onChangeText={handleBizWebChange}
                    autoComplete="off"
                    placeholder="Website of business"
                  />

                  {bizWebError ? (
                    <Text style={{ color: "red", fontSize: 12 }}>
                      Invalid Website of business
                    </Text>
                  ) : null}
                </FormControl>
                <FormControl w={"49%"}>
                  <FormControl.Label>
                    Phone number for ordering at business:
                  </FormControl.Label>

                  <Input
                    maxLength={12}
                    value={bizOrderPhone}
                    onChangeText={(t) =>
                      setBizOrderPhone(t.replace(/[^0-9]/g, ""))
                    }
                    autoComplete="off"
                    placeholder="Phone number for ordering at business"
                  />
                </FormControl>
                <FormControl>
                  <FormControl.Label>
                    Email address for sending orders to business:
                  </FormControl.Label>

                  <Input
                    maxLength={25}
                    value={bizOrderEmail}
                    onChangeText={handleEmailChange}
                    autoComplete="off"
                    placeholder="Email address for sending orders to business"
                  />
                  {bizOrderEmailError ? (
                    <Text style={{ color: "red", fontSize: 12 }}>
                      {bizOrderEmailError}
                    </Text>
                  ) : null}
                </FormControl>
                <FormControl>
                  <FormControl.Label>Businees Cusines</FormControl.Label>
                  <Multiselect
                    placeholder="Select Cusines"
                    isObject={false}
                    onKeyPressFn={function noRefCheck() {}}
                    onRemove={(list, item) => {
                      setBizCusines(list);
                    }}
                    onSearch={function noRefCheck() {}}
                    onSelect={(list, item) => {
                      setBizCusines(list);
                    }}
                    options={Cuisine ? Cuisine.map((c) => c["cuisName"]) : []}
                  />
                </FormControl>
              </HStack>
            </View>
          )}

          {wizard === 5 && (
            <AccessibilityForm
              onScoreChange={handleScoreChange}
              onFormChange={handleFormChange}
              formData={formData}
            />
          )}
          {wizard < 5 && (
            <Center>
              <VStack w={"100%"} space={2}>
                <Button
                  onPress={() => {
                    if (wizard === 0) {
                      const hasLetter = /[a-zA-Z]/.test(bizName);
                      const isBizTypeValid = bizType?.typeName?.length > 1;

                      if (bizName.length > 0 && hasLetter && isBizTypeValid) {
                        Setwizard(wizard + 1);
                      } else {
                        let warningMsg =
                          "Please fill in all the required fields";

                        if (!bizName.length) {
                          warningMsg = "Business name is required";
                        } else if (!hasLetter) {
                          warningMsg =
                            "Business name must contain at least one letter";
                        } else if (!isBizTypeValid) {
                          warningMsg = "Please select a valid business type";
                        }

                        Notiflix.Report.Warning("Warning", warningMsg, "Close");
                      }
                    }
                    if (wizard === 1) {
                      if (selected) {
                        Setwizard(wizard + 1);
                      } else {
                        Notiflix.Report.Warning(
                          "Warning",
                          `Please enter your business address`,
                          "Close"
                        );
                      }
                    }
                    if (wizard === 2) {
                      if (
                        bizInsideLowSeatNo.length > 0 &&
                        bizInsideHighSeatNo.length > 0 &&
                        bizOutsideLowSeatNo.length > 0 &&
                        bizOutsideHighSeatNo.length > 0 &&
                        bizInsideLowTableNo.length > 0 &&
                        bizInsideHighTableNo.length > 0 &&
                        bizOutsideLowTableNo.length > 0 &&
                        bizOutsideHighTableNo.length > 0
                      ) {
                        Setwizard(wizard + 1);
                      } else {
                        Notiflix.Report.Warning(
                          "Warning",
                          `please fill all inputs`,
                          "Close"
                        );
                      }
                    }
                    if (wizard === 3) {
                      Setwizard(wizard + 1);
                    }
                    if (wizard === 4) {
                      Setwizard(wizard + 1);
                    }
                  }}
                >
                  Next
                </Button>
                <Button
                  colorScheme="coolGray"
                  isDisabled={wizard < 1}
                  onPress={() => {
                    Setwizard(wizard - 1);
                  }}
                >
                  Back
                </Button>
              </VStack>
            </Center>
          )}

          {wizard === 5 && (
            <VStack>
              <Button
                mb={2}
                onPress={() => {
                  if (
                    bizPhone.length > 0 &&
                    bizEmail.length > 0 &&
                    bizWeb.length > 0 &&
                    bizOrderPhone.length > 0 &&
                    bizOrderEmail.length > 0 &&
                    Object.keys(images).length > 0
                  ) {
                    const BizInfo = {
                      bizName,
                      bizType,
                      bizInsideLowSeatNo,
                      bizInsideHighSeatNo,
                      bizOutsideLowSeatNo,
                      bizOutsideHighSeatNo,
                      bizInsideLowTableNo,
                      bizInsideHighTableNo,
                      bizOutsideLowTableNo,
                      bizOutsideHighTableNo,
                      bizMondayOpen,
                      bizMondayClose,
                      bizTuesdayOpen,
                      bizTuesdayClose,
                      bizWednesdayOpen,
                      bizWednesdayClose,
                      bizThursdayOpen,
                      bizThursdayClose,
                      bizFridayOpen,
                      bizFridayClose,
                      bizSaturdayOpen,
                      bizSaturdayClose,
                      bizSundayClose,
                      bizSundayOpen,
                      BreakfastS,
                      BreakfastF,
                      bizLunchOpen,
                      bizLunchClose,
                      bizDinnerOpen,
                      bizDinnerClose,
                      bizPhone,
                      bizEmail,
                      bizWeb,
                      bizOrderPhone,
                      bizOrderEmail,
                      bizLat: selected["lat"],
                      bizLon: selected["lng"],
                      images,
                      bizCuisines,
                      bizAccessRating,
                      ...formData,
                      ...bizAddress,
                    };
                    dispatch(AddBiz(BizInfo, history));
                  } else {
                    Notiflix.Report.Warning(
                      "Warning",
                      `please fill all Business Contacts information`,
                      "Close"
                    );
                  }
                }}
                colorScheme="danger"
              >
                Submit
              </Button>
              <Button
                colorScheme="coolGray"
                mb={500}
                isDisabled={wizard < 1}
                onPress={() => {
                  Setwizard(wizard - 1);
                }}
              >
                Back
              </Button>
            </VStack>
          )}
        </VStack>
      </Center>
    </VStack>
  );
};

const mapStateToProps = (state) => {
  //
  return {
    auth: state.firebase.auth,
  };
};

export default compose(connect(mapStateToProps))(AddBusiness);
